'use client';
import { useRef, useCallback, useEffect } from 'react';

const useTimeout = (action, delay, options = {
    autoInvoke: false
})=>{
    const { autoInvoke } = options;
    const callbackRef = useRef(null);
    const timeoutRef = useRef(null);
    const start = useCallback((...callbackParams)=>{
        if (!timeoutRef.current) {
            timeoutRef.current = window.setTimeout(()=>{
                callbackRef.current == null ? void 0 : callbackRef.current.call(callbackRef, callbackParams);
                timeoutRef.current = null;
            }, delay);
        }
    }, [
        delay
    ]);
    const clear = useCallback(()=>{
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    useEffect(()=>{
        callbackRef.current = action;
    }, [
        action
    ]);
    useEffect(()=>{
        if (autoInvoke) {
            start();
        }
        return clear;
    }, [
        clear,
        delay,
        autoInvoke,
        start
    ]);
    return {
        start,
        clear
    };
};

export { useTimeout };
//# sourceMappingURL=useTimeout.js.map
